// MiniUserModal.jsx
import React, { useRef, useEffect, useState } from 'react';
import LoggedInMenu from './LoggedInMenu';
import Backdrop from '../../mainPage/BackDrop';
import SocialMediaIcons from '../../components/miniButtons/SocialMediaIcons';
import ConfirmDialog from '../../components/ConfirmDialog';
import CloseIcon from '@mui/icons-material/Close';
import PersonIcon from '@mui/icons-material/Person';
import LoginIcon from '@mui/icons-material/Login';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import LockResetIcon from '@mui/icons-material/LockReset';
import LogoutIcon from '@mui/icons-material/Logout';
import { useDispatch } from 'react-redux';
import { setShowModalUser, setShowPasswordResetModal } from '../../reducers/auth.reducer'; // Подключили экшены напрямую

const MiniUserModal = ({
    auth,
    logout,
    visible,
    contactNumber,
    closeShowMiniModal,
    setShowMiniUserModal,
    typeModal,
    user,
}) => {
    const dispatch = useDispatch();
    const [showConfirm, setShowConfirm] = useState(false);
    const modalRef = useRef(null);

    useEffect(() => {
        if (!visible) setShowConfirm(false);
    }, [visible]);

    useEffect(() => {
        if (!auth) setShowConfirm(false);
    }, [logout, auth]);

    const handleShowConfirm = () => {
        setShowConfirm(true);
    };

    if (!visible) return null;

    const userTitle = [user?.firstName, user?.lastName].filter(Boolean).join(' ').trim() ||
        user?.fullName ||
        user?.email ||
        'Профиль';

    const userEmail = user?.email || '';

    // Единый хендлер для кнопок-действий
    const handleActionClick = (mode) => {
        if (mode === 'reset') {
            dispatch(setShowPasswordResetModal(true));
        } else {
            dispatch(setShowModalUser({ forceShow: true, mode, role: 'user' }));
        }
        setShowMiniUserModal(false);
    };

    const renderGuestActions = () => (
        <div className="headerNav__guestActions">
            <div className="headerNav__guestMainActions">
                <button type="button" onClick={() => handleActionClick('login')} className="headerNav__button">
                    <LoginIcon />
                    <span>Войти</span>
                </button>
                <button type="button" onClick={() => handleActionClick('signup')} className="headerNav__button">
                    <PersonAddAltIcon />
                    <span>Регистрация</span>
                </button>
            </div>
            <button
                type="button"
                onClick={() => handleActionClick('reset')}
                className="headerNav__button headerNav__button--reset"
            >
                <LockResetIcon />
                <span>Забыли пароль?</span>
            </button>
        </div>
    );

    const renderGuestActionsRight = () => (
        <div className="miniModalRight__guestActions">
            <button type="button" onClick={() => handleActionClick('login')} className="miniModalRight__action">
                <span className="miniModalRight__actionIcon"><LoginIcon /></span>
                <span>Войти</span>
            </button>
            <button type="button" onClick={() => handleActionClick('signup')} className="miniModalRight__action">
                <span className="miniModalRight__actionIcon"><PersonAddAltIcon /></span>
                <span>Регистрация</span>
            </button>
            <button
                type="button"
                onClick={() => handleActionClick('reset')}
                className="miniModalRight__action miniModalRight__action--reset"
            >
                <span className="miniModalRight__actionIcon"><LockResetIcon /></span>
                <span>Восстановить пароль</span>
            </button>
        </div>
    );

    const renderUserCard = (right = false) => {
        if (!auth) {
            return (
                <div className={right ? 'miniModalRight__identity' : 'headerNav__identity'}>
                    <div className={right ? 'miniModalRight__avatar' : 'headerNav__avatar'}>
                        <PersonIcon />
                    </div>
                    <div className={right ? 'miniModalRight__identityMain' : 'headerNav__identityMain'}>
                        <div className={right ? 'miniModalRight__identityTitle' : 'headerNav__identityTitle'}>
                            Личный кабинет
                        </div>
                        <div className={right ? 'miniModalRight__identityText' : 'headerNav__identityText'}>
                            Войдите или зарегистрируйтесь
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className={right ? 'miniModalRight__identity' : 'headerNav__identity'}>
                <div className={right ? 'miniModalRight__avatar auth-avatar' : 'headerNav__avatar auth-avatar'}>
                    {String(userTitle).slice(0, 1).toUpperCase()}
                </div>
                <div className={right ? 'miniModalRight__identityMain' : 'headerNav__identityMain'}>
                    <div className={right ? 'miniModalRight__identityTitle' : 'headerNav__identityTitle'}>
                        {userTitle}
                    </div>
                    {userEmail && (
                        <div className={right ? 'miniModalRight__identityText' : 'headerNav__identityText'}>
                            {userEmail}
                        </div>
                    )}
                </div>
            </div>
        );
    };

    const renderContent = () => {
        switch (typeModal) {
            case 'rightModal':
                return (
                    <aside
                        ref={modalRef}
                        className={`miniModalRight ${visible ? 'visible' : ''}`}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="miniModalRight__top">
                            <div className="miniModalRight__brand">
                                <span className="miniModalRight__brandDot" />
                                <span>ALOTB</span>
                            </div>
                            <button
                                type="button"
                                className="miniModalRight__close"
                                onClick={closeShowMiniModal}
                                aria-label="Закрыть"
                            >
                                <CloseIcon />
                            </button>
                        </div>

                        <div className="miniModalRight__contentModal">
                            {renderUserCard(true)}
                            <div className="miniModalRight__buttonContainer" onClick={(e) => e.stopPropagation()}>
                                {auth ? (
                                    <button
                                        type="button"
                                        onClick={handleShowConfirm}
                                        className="miniModalRight__action miniModalRight__action--danger"
                                    >
                                        <span className="miniModalRight__actionIcon">
                                            <LogoutIcon />
                                        </span>
                                        <span>Выйти из аккаунта</span>
                                    </button>
                                ) : (
                                    renderGuestActionsRight()
                                )}
                            </div>
                            <div className="miniModalRight__menu">
                                <LoggedInMenu auth={auth} typeModal={typeModal} user={user} />
                            </div>
                        </div>

                        <div className="miniModalRight__footer">
                            {contactNumber && (
                                <a href={`tel:${contactNumber}`} className="miniModalRight__phone">
                                    {contactNumber}
                                </a>
                            )}
                            <SocialMediaIcons />
                        </div>
                    </aside>
                );

            default:
                return (
                    <div onClick={closeShowMiniModal} className="headerNav__miniModal" ref={modalRef}>
                        <div className="headerNav__contentModal" onClick={(e) => e.stopPropagation()}>
                            {renderUserCard(false)}
                            <div className="headerNav__buttonContainer" onClick={(e) => e.stopPropagation()}>
                                {auth ? (
                                    <button
                                        type="button"
                                        onClick={handleShowConfirm}
                                        className="headerNav__button headerNav__button--logout"
                                    >
                                        <LogoutIcon />
                                        <span>Выйти из аккаунта</span>
                                    </button>
                                ) : (
                                    renderGuestActions()
                                )}
                            </div>
                            <LoggedInMenu auth={auth} setShowMiniUserModal={setShowMiniUserModal} user={user} />
                        </div>
                        <div className="headerNav__MiniModalNumber">
                            {contactNumber && (
                                <a href={`tel:${contactNumber}`}>
                                    <span>{contactNumber}</span>
                                </a>
                            )}
                        </div>
                    </div>
                );
        }
    };

    return (
        <>
            <div className="headerNav__renderContentContainer">
                {renderContent()}
                <Backdrop visible={visible} closeShowMiniModal={closeShowMiniModal} />
            </div>
            <ConfirmDialog
                title="Вы точно хотите выйти со своего профиля?"
                description="Подтвердить выход"
                open={showConfirm}
                handleClose={() => setShowConfirm(false)}
                handleSubmit={logout}
            />
        </>
    );
};

export default MiniUserModal;